import React from 'react';
import styled from '@emotion/styled';
import Flex from './Flex';
import Row from './Row';
import Column from './Column';

export default styled('div')`
	background: #fff;
	color: #000000;
	line-height: 20px;
	margin-bottom: 30px;
	padding: 20px;
`;

const Item = styled('div')`
	${Flex}
	${Row}
	padding-bottom: 10px;
	margin-bottom: 10px;
	border-bottom: 1px solid #e1edf1;
`;

export function ResultItem({ className, name, children }) {
	return (
		<Item className={className} data-cy="result-item">
			<Column basis="70%">{name}</Column>
			<Column basis="30%">{children}</Column>
		</Item>
	);
}
